import { useThemeContext } from '@huggg/react-components';
import hugggB2BLogo from 'assets/img/logos/b2b-huggg-logo.svg';
import hugggB2GLogo from 'assets/img/logos/b2g-huggg-logo-dark.svg';
import dictionary from 'config/dictionary';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './powered-by-huggg.module.scss';

const PoweredByHuggg = (props) => {
  const { operator, isWelfare } = useThemeContext();

  if (!operator.showHugggPromotions) return null;

  const logo = isWelfare ? hugggB2GLogo : hugggB2BLogo;

  return (
    <div className={styles.poweredByHuggg}>
      Powered by{' '}
      <img src={logo} alt={dictionary.hugggLogoAlt} className={styles.logo} />
    </div>
  );
};

PoweredByHuggg.propTypes = {
  className: PropTypes.string,
};

export default PoweredByHuggg;
